export const MIN_PER_HOUR = 60;
export const SEC_PER_MIN = 60;
export const NO_VALUE = '--';
export const PSIG_TO_INHG_FACTOR = 2.03602;

/** Threshold for K-suffix compact display (axis labels, chart ticks) */
export const COMPACT_NUMBER_K_THRESHOLD = 1000;
/** Threshold for M-suffix compact display (axis labels, chart ticks) */
export const COMPACT_NUMBER_M_THRESHOLD = 1000000;
/** Values below this use one decimal place in compact display */
export const COMPACT_NUMBER_DECIMAL_THRESHOLD = 100;

export const SUPPORTED_UNITS = {
  // Booleans
  ON_OFF: 'on-off',
  OPEN_CLOSED: 'open-closed',
  BOOLEAN: 'boolean',

  // Temperature
  DEGREES_C: '°c',
  C: 'c', // alias for °c
  CELSIUS: 'celsius', // alias for °c
  DEGREES_F: '°f',
  F: 'f', // alias for °f
  FAHRENHEIT: 'fahrenheit', // alias for °f
  DEGREES_K: '°k',
  K: 'k', // alias for °k
  KELVIN: 'kelvin', // alias for °k

  // Time
  HRS: 'hrs',
  MIN: 'min',
  SEC: 'sec',
  DURATION: 'duration',
  TIMER: 'timer',

  // Frequency
  HZ: 'hz',
  KHZ: 'khz',
  MHZ: 'mhz',
  GHZ: 'ghz',

  // Electrical
  A: 'a',
  AMPS: 'amps',
  KVA: 'kva',
  KVAH: 'kvah',
  KVAR: 'kvar',
  KVARH: 'kvarh',
  KW: 'kw',
  KWH: 'kwh',
  V: 'v',
  VDC: 'vdc',

  // Pressure
  INHG: 'inhg',
  PSI: 'psi',
  PSIA: 'psia',
  PSIG: 'psig',
  /** BFF display-template type for suction pressure (positive PSIG / negative inHG) */
  PSIG_INHG: 'psig-inhg',

  // Percentage
  PERCENT_SYMBOL: '%',
  PERCENT: 'percent', // alias for %
  PERCENTAGE: 'percentage', // alias for %

  // Refrigeration
  KW_PER_TR: 'kw/tr',
  TR: 'tr',

  // Other
  $: '$',
  $_PER_KWH: '$/kwh',
  PER_KWH: '/kwh',
  DIRECTION: 'direction',
  DEG: 'deg',
  DEGREE: 'degree', // alias for deg
  DEGREES: 'degrees', // alias for deg
  NONE: 'none',
  NUMBER: 'number',
  /** Compact K/M numeric display for chart axis labels (no engineering unit) */
  COMPACT_NUMBER: 'compact-number',
  FT: 'ft',
  GPM: 'gpm',
  MPH: 'mph',
  PID: 'pid',
  PPM: 'ppm',
  RPM: 'rpm',
  STRING: 'string',
} as const;

/** 8-point compass labels clockwise from North */
export const WIND_DIRECTIONS_CLOCKWISE_FROM_N = [
  'N',
  'NE',
  'E',
  'SE',
  'S',
  'SW',
  'W',
  'NW',
] as const;

/** Display label written to formatted output for MPH values */
export const MPH_OUTPUT_LABEL = 'MPH';

/** Display label written to formatted output for angular degree values */
export const DEGREE_OUTPUT_LABEL = '°';

/** Display labels written to formatted output for PSI gauge values */
export const PSI_OUTPUT_LABELS = {
  PSIG: 'PSIG',
  INHG: 'inHG',
} as const;

/** Source unit keys eligible for sign-based PSIG/inHG output selection */
export const PSI_GAUGE_SOURCE_UNITS = [
  SUPPORTED_UNITS.PSI,
  SUPPORTED_UNITS.PSIA,
  SUPPORTED_UNITS.PSIG,
] as const;
